// Växlar mellan projektlistan och portföljöversikten – samma data, olika zoom.
import React from "react";
import { NavLink } from "react-router-dom";
import { Building2, FolderOpen } from "lucide-react";

const base =
  "flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors";

const ProjectViewSwitcher: React.FC = () => (
  <div className="inline-flex items-center gap-1 rounded-lg bg-muted p-1">
    <NavLink
      to="/uppdrag"
      end
      className={({ isActive }) =>
        `${base} ${isActive ? "bg-background shadow-sm" : "text-muted-foreground hover:text-foreground"}`
      }
    >
      <FolderOpen className="h-4 w-4" />
      Mina projekt
    </NavLink>
    <NavLink
      to="/portfolj"
      className={({ isActive }) =>
        `${base} ${isActive ? "bg-background shadow-sm" : "text-muted-foreground hover:text-foreground"}`
      }
    >
      <Building2 className="h-4 w-4" />
      Portföljöversikt
    </NavLink>
  </div>
);

export default ProjectViewSwitcher;
